import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  text: string;
  iconStyleDef?: React.CSSProperties;
  styleDef?: React.CSSProperties;
  status?: string;
  type?: string;
  icon?: string;
  id?: string;
  clickEvent: (id?: string) => void;
}

const DefaultButton: FC<Props> = ({
  text,
  clickEvent,
  iconStyleDef = {},
  styleDef,
  type,
  icon = '',
  status,
  id = '',
}) => {
  let iconStyle = '';
  icon !== '' ? (iconStyle = '_icon') : '';
  const clickEvt = () => {
    id !== '' ? clickEvent(id) : clickEvent();
  };
  return (
    <div className={['_default_btn_box_div', type, iconStyle].join(' ')}>
      {status !== 'disable' ? (
        <button className={['_btn', status].join(' ')} onClick={e => clickEvt()} style={styleDef}>
          {icon !== '' ? (
            <div className="_icon" style={iconStyleDef}>
              <i className={icon} />
            </div>
          ) : (
            ''
          )}

          <div className="_text">{text}</div>
        </button>
      ) : (
        <button className="_btn disable" style={styleDef}>
          {icon !== '' ? (
            <div className="_icon" style={iconStyleDef}>
              <i className={icon} />
            </div>
          ) : (
            ''
          )}

          <div className="_text">{text}</div>
        </button>
      )}
    </div>
  );
};

export default DefaultButton;
